const URI_RE = /^[A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=]+$/

export const isValidURL = (url: string): boolean => URI_RE.test(url)
